import { useT } from "@/i18n/LanguageContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_website-builder-1674/artifacts/923t2kyx_image.png";

export default function Footer() {
  const { t } = useT();
  const year = new Date().getFullYear();
  const copy = t.footer.copyright.replace("{year}", year);

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0A0A] overflow-hidden"
    >
      {/* Big brand logo */}
      <div className="border-b border-white/10 px-6 sm:px-10 pt-20 pb-12 flex items-center justify-center">
        <img
          src={LOGO_URL}
          alt="S&K Facade Panels"
          data-testid="footer-logo"
          className="h-40 sm:h-56 md:h-72 w-auto object-contain"
        />
      </div>

      <div className="grid grid-cols-12 px-6 sm:px-10 py-10 gap-6">
        <div className="col-span-12 md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50">
            {t.brand.name}
          </p>
          <p className="text-sm text-white/60 mt-3 max-w-sm">
            {t.footer.description}
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-3">
            {t.footer.contact}
          </p>
          <a
            href="tel:+38978351715"
            data-testid="footer-phone"
            className="block text-sm text-white/80 hover:text-white"
          >
            +389 78 351 715
          </a>
          <a
            href="mailto:sktrade.importexport@gmail.com"
            data-testid="footer-email"
            className="block text-sm text-white/80 hover:text-white break-all mt-1"
          >
            sktrade.importexport@gmail.com
          </a>
        </div>

        <div className="col-span-6 md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-3">
            {t.footer.office}
          </p>
          <p className="text-sm text-white/80">{t.footer.city}</p>
          <p className="text-sm text-white/80">{t.footer.country}</p>
        </div>

        <div className="col-span-12 md:col-span-2 md:text-right">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/40">
            {copy}
          </p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/40 mt-1">
            {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
